import React from "react";
import { twMerge } from "tailwind-merge";
import { Label } from "@/components/ui/label/Label";

export interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  error,
  hint,
  children,
  className = "",
}: FormFieldProps) {
  return (
    <div className={twMerge("space-y-0", className)}>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {error ? (
        <p className="mt-1.5 text-xs text-error-500">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-xs text-text-secondary dark:text-gray-400">{hint}</p>
      ) : null}
    </div>
  );
}

export default FormField;
